/** @format */

import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";


console.log("initiating store");

let store;

if (process.env.REACT_APP_NODE_ENV === "local") {
  // require dev dependencies
  const reduxImmutableStateInvariant = require("redux-immutable-state-invariant").default;
  const { composeWithDevTools } = require("redux-devtools-extension");
  const logger = require("redux-logger").default;

  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

  store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(
        reduxImmutableStateInvariant(),
        logger,
        thunk
      )
    )
  );
} else {
  store = createStore(
    rootReducer,
    compose(
      applyMiddleware(
        thunk
      )
    )
  );
}

export default store;
